import { composeHOCs } from 'shared/utils/composeHOCs';
import { memo, ReactElement } from 'react';
import { withProcessesData } from 'components/common/withProcessesData';
import { withRedirect } from 'components/common/withRedirect';
import { withIssueForm } from 'components/common/withIssueForm';
import { withUsers } from 'components/dataProviders/withUsers';
import {
  withRequiredInspectionTemplate,
} from 'components/dataProviders/withRequiredInspectionTemplate';
import { withInspectionStore } from 'store/inspection';
import { useInspectionWizardController } from './controller/useInspectionWizardController';
import { InspectionWizardContent } from './components/InspectionWizardContent';

function InspectionWizardView(): ReactElement {
  const controller = useInspectionWizardController();
  return <InspectionWizardContent {...controller} />;
}

const InspectionWizardViewWithProviders = memo(
  composeHOCs(
    withProcessesData,
    withIssueForm,
    withRedirect,
    withRequiredInspectionTemplate,
    withUsers,
    withInspectionStore
  )(InspectionWizardView)
);

export const MemoInspectionWizard = InspectionWizardViewWithProviders;
export default InspectionWizardViewWithProviders;
